import { SaleService } from "@/services";
import { i18n } from "@/setup/i18n-setup";
import { Job } from "./job";

export const NotificationTypeNotify = "notify";
export const NotificationTypeError = "error";

export class Notification {
	ID:number = 0;
	Date:Date = new Date();
	Type:string = "";
	Title:string = "";
	Message:string = "";
	UserID:number = 0;
	IsCustom:boolean = false
	IsRead:boolean = false;
	Data:any = {};
	DeletionDate:Date | null = null;
	HideForClient:boolean = false;

	constructor(data:any) {
		if (!data) return;
		this.ID = data.ID;
		this.Date = new Date(data.Date * 1000);
		this.Type = data.Type;
		this.Title = data.Title;
		this.Message = data.Message;
		this.UserID = data.UserID;
		this.IsCustom = data.IsCustom;
		this.IsRead = data.IsRead;
		this.Data = data.Data;
		this.HideForClient = data.HideForClient;
		if (data.DeletionDate) {
			this.DeletionDate = new Date(data.DeletionDate);
		}
	}

	private getTitleProcessData():any {
		if (!this.Data) return this.Data;
		let copy = {...this.Data};
		if (this.Title == "title-job-crashed") {
			copy.Job = Job.getTranslatedJobName(this.Data.Job, []);
		}
		return copy;
	}

	getTitle():string{
		if (this.IsCustom) return this.Title;
		let data = this.getTitleProcessData();
		return i18n.t(`common.notifications.${this.Title}`, data).toString();
	}

	getShortTitle():string{
		if (this.IsCustom) return this.Title;
		let data = this.getTitleProcessData();
		return i18n.t(`common.short-notifications.${this.Title}`, data).toString();
	}

	private getMessageAutomaticAfleveringsbonnenCreated():string{
		let docType = "afleveringsbon";
		let docTypes = "afleveringsbonnen";
		let docTypeObj = SaleService.saleTypes.find(s=>s.ID == this.Data.saleType);
		if (docTypeObj) {
			docType = docTypeObj.DisplayedName;
			docTypes = docTypeObj.NamePlural;
		}
		return i18n.tc("common.notifications.message-automatic-afleveringsbonnen-created", this.Data.createdDocsCount, {
			createdCount: this.Data.createdDocsCount,
			duration: this.Data.duration,
			docType,
			docTypes,
		}).toString();
	}

	getMessage():string {
		if (this.IsCustom) return this.Message;
		if (this.Message == "message-automatic-afleveringsbonnen-created") {
			return this.getMessageAutomaticAfleveringsbonnenCreated();
		}
		if (this.Message == "message-multiple-purchases-sent-to-bookkeeper"){
			return i18n.tc("common.notifications."+this.Message, this.Data.count, this.Data).toString();
		}
		return i18n.t("common.notifications."+this.Message, this.Data).toString();
	}
}